const getDefaultRouteAfterSignIn = (user?: Partial<User>) => {
  if (user?.isAdmin || user?.isCoach) return '/admin/dashboard';
  if (user?.isSales) return '/admin/clients';

  return '/dashboard';
};

export default getDefaultRouteAfterSignIn;
